import React from 'react'
import Card, { TitleCard } from '../../core/Card'
import './FavoriteTrip.css'
import { Col, Popconfirm, message, Button, Alert, Input, Form, Checkbox, Select, Radio, Row } from 'antd';
import { Icon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../../core/icons'
import makeField from '../makeField'

import { Field, reduxForm } from 'redux-form'
const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;

const required = value => (value ? undefined : 'Required')

const AInput = makeField(Input);
const ASelect = makeField(Select);
const ATextArea = makeField(TextArea);

const FromOrToField = ({places, label, name}) =>
    <Field
      label={label}
      name={name}
      component={ASelect}
      notFoundContent="Add a favorite place in the Favorite Places section."
      formLayout="horizontal"
    >
      {places.map(place=>
        <Option value={place.token_id}>
          <Row type="flex" justify="space-between" align="top">
            <Col>
              <Icon height="18" type={place.icon_name}/>
            </Col>
            <Col>
              {place.name}  ({place.street})
            </Col>
          </Row>
        </Option>
      )}
    </Field>

const FavoriteTrip = ({ purposes, places, goBack, submitSucceeded, submitFailed, error, onDelete, title, buttonTitle, onRemoteSubmit, pristine, reset, submitting }) => {
  return (
    <div className="FavoriteTrip">
      <TitleCard showBackButton>
        <h1>{title}</h1>
        { submitSucceeded ? <Alert message="Saved successfully" type="success" /> : null}
        { submitFailed ? <Alert message="Oops there was an error saving! You might be missing required fields." type="error" /> : null}
        <Button loading={submitting} disabled={pristine} onClick={onRemoteSubmit} type="primary">{buttonTitle}</Button>
        { onDelete &&
          <Popconfirm title="Are you sure?" placement="left" onConfirm={onDelete} okText="Yes" cancelText="No">
            <Button type="danger" icon="delete"></Button>
          </Popconfirm>
          }
      </TitleCard>

      <Card>
        <form>
          <h3>Anytime I drive...</h3>

          <FromOrToField label="From" name="start_place_token" places={places}/>
          <FromOrToField label="To" name="end_place_token" places={places}/>

          <h3>Classify as...</h3>

          <Field
            label="Purpose"
            name="purpose"
            component={ASelect}
            validate={[required]}
            formLayout="horizontal"
            >
            {purposes.map(purpose=>
              <Option value={purpose}>
                <Row type="flex" justify="space-between" align="middle">
                  <Icon type={purpose} width="18" height="18"/>
                  <div>{purpose}</div>
                </Row>
              </Option>
            )}
          </Field>

          <Field
            label="Notes"
            name="notes"
            component={ATextArea}
            formLayout="horizontal"
          />

          {error && <Alert message={error} type="error" />}

        </form>
      </Card>
    </div>
  )
}

export default FavoriteTrip



// WEBPACK FOOTER //
// ./src/account/favorite-trips/FavoriteTrip.jsx